import {Component, Input} from '@angular/core';

@Component({
  selector: 'nc-decision-dialog',
  templateUrl: './nc-decision-dialog.component.html',
  styleUrls: ['./ns-decision-dialog.component.scss']
})
export class NcDecisionDialogComponent {
  @Input() titleLabel: string;
  @Input() yesLabel: string = 'yes';
  @Input() noLabel: string = 'no';
}
